import React from 'react';
import _ from 'lodash';
import cx from 'classnames';
import PopoverHelperV2 from '../PopoverHelperV2';
import GenericSelector from './GenericSelector';


class DropdownSelector extends GenericSelector {

    static defaultProps = {
        noSelectedClass: false,
        multiselect: false,
		customSelection: false,
		minCustomSelection: 3,
        showChevron: false,
        allowSearch: true

    }

    constructor(props) {
        super(props);
        this.state = {
            popoverOpened: false,
			isCustomSelected:false,
            search: ''
        }
    }

	handleRegularSelected = (item) => {
		const {isCustomSelected} = this.state;
		const {customSelection} = this.props;

		if (customSelection && isCustomSelected) {
			this.setState({isCustomSelected: false})
		}
		this.onChange(item)
	}

	handleCustomSelected = () => {
		const {search, isCustomSelected} = this.state;
		const {idKey, titleKey} = this.props;

		if (isCustomSelected) {
			this.onChange({
				[idKey]: 0
			})
			this.setState({isCustomSelected: false});
		} else {
			this.onChange({
				[idKey]: search,
				[titleKey]: search,
				custom: true
			})
			this.setState({isCustomSelected: true});
		}

	}

	componentDidUpdate(prevProps, prevState) {
		const { search } = this.state;
		const { customSelection, minCustomSelection, idKey, titleKey, options } = this.props;

		if (search !== prevState.search) {
			if (customSelection && search.length >= minCustomSelection) {
				// handle auto custom selection with typing if there is no options
				const optionsToShow = _.isEmpty(search)
					? options
					: _.filter(options, opt => opt[titleKey]?.toLowerCase().includes(search.toLowerCase()));
				if(optionsToShow.length === 0){
					this.onChange({
						[idKey]: search,
						[titleKey]: search,
						custom: true
					})
					this.setState({isCustomSelected: true});
				}
			}

		}
	}

	render() {
        const { popoverOpened, search, isCustomSelected } = this.state;
        const { options, selections, id, className, idKey, titleKey, noSelectedClass, multiselect, renderRadio, allowSearch, children, renderIcon, disableCheckbox, hideExpander,
			isHeader, disablePopup, optionsDisabled, customSelection, minCustomSelection, customDropdownItem, renderDeselectIcon, renderExpandIcon, renderItemSuffix } = this.props;
		const optionsToShow = _.isEmpty(search)
			? options
			: _.filter(options, opt => opt[titleKey]?.toLowerCase().includes(search.toLowerCase()));

		const allSelected = selections?.length == _.filter(options, opt => !_.includes(optionsDisabled, opt[idKey])).length;

		const shouldRenderDeselectIcon = renderDeselectIcon && !_.isEmpty(selections);

		return <div key={`selector_${id}`} className={cx(isHeader?className:'dropdown-selector', className)}>
            <div className={cx('popover-opener',{'selected':!_.isEmpty(selections)&&!noSelectedClass})} data-popover-id={`popover_${id}`} onClick={() => (disablePopup ? this.onPopoverChange(false) : this.onPopoverChange(!popoverOpened))}>
                {children ? children : this.renderTitle()}
                {hideExpander ? null : shouldRenderDeselectIcon ? this.renderDeselectIcon() : renderExpandIcon ? this.renderExpandIcon() : this.renderChevron()}
            </div>
            <PopoverHelperV2 id={`popover_${id}`} show={popoverOpened} closePopover={() => this.onPopoverChange(false)}>
                {allowSearch && <div className='popover-controller'>
                    <div className={cx('p-relative width-100', {'mr-10':multiselect})}>
                        <input type='text' placeholder={customSelection ? 'Select existing or enter a custom one manually':'Search...'} value={search || ''} onChange={e => this.onSearch(e.currentTarget.value)} />
                        <span className='material-symbols-outlined' onClick={() => this.onSearch('')}>close</span>
                    </div>
                    {multiselect && <span className='select-all-btn' onClick={this.onSelectAll}>{allSelected ? 'Unselect All' : 'Select All'}</span>}
                </div>}
                <div className='dropdown-items'>
					{customDropdownItem ? customDropdownItem : null}
					{_.map(optionsToShow, item => {
						if(item[idKey] !== -1){
							const isSelected = this.onCheckIfSelected(item);
							const enabled = 'enabled' in item ? item.enabled : true;
							return  enabled && <div key={`dropdown-${id}_${item[idKey]}`} className={cx('dp-item', { 'inactive': !isSelected }, { 'disabled': _.includes(optionsDisabled, item[idKey]) }, { 'dp-item-with-suffix': renderItemSuffix })} onClick={() => this.handleRegularSelected(item)}>
								<span className='dp-item-main'>
									{!disableCheckbox && renderRadio ? this.renderCircleCheckbox(isSelected) : !disableCheckbox && this.renderCheckbox(isSelected)}
									{renderIcon && item?.icon}
									{item[titleKey]}
								</span>
								{renderItemSuffix && <span className='dp-item-suffix'>{renderItemSuffix(item, isSelected)}</span>}
							</div>;
						}

					})}

					{customSelection && optionsToShow.length === 0 && search.length >= minCustomSelection && (
						<div
							onClick={() => this.handleCustomSelected()}
							className={cx('dp-item', { 'inactive': !isCustomSelected })}>
							{!disableCheckbox && this.renderCheckbox(isCustomSelected)}
							{search}
						</div>

					)}
				</div>
            </PopoverHelperV2>
        </div>;
    }
}

export default DropdownSelector;
